import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Home from "./home";
import Account from "./account";
import JobAds from "./job-ads";
import Organisation from "./organisation";
import Members from "./members";
import Pool from "./pool";
import Mcp from "./mcp";
import Brain from "./brain";
import LinkedInRotation from "./linkedin-rotation";
import Usage from "./usage";
import ChatLayout from "@/components/ChatLayout";

import { Layout } from "./layout";

export default function Recruiter() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="account/*" element={<Account />} />
        <Route path="job-ads/*" element={<JobAds />} />
        <Route path="organisation/*" element={<Organisation />} />
        <Route path="members" element={<Members />} />
        <Route path="pool" element={<Pool />} />
        <Route path="mcp/*" element={<Mcp />} />
        <Route path="brain/*" element={<Brain />} />
        <Route path="linkedin" element={<LinkedInRotation />} />
        <Route path="usage" element={<Usage />} />
        <Route path="connected-apps" element={<Navigate to="/recruiter/mcp/connected-apps" replace />} />
        <Route path="chat/*" element={<ChatLayout basePath="/recruiter/chat" />} />
      </Route>
    </Routes>
  );
}
